import { getError } from "@/utils/get-error";
import { axiosInstance } from "@dexteel/mesf-core";

export const recoverSnapshot = async (
	days: number | string,
): Promise<
	| {
			ok: false;
			message: string;
	  }
	| {
			ok: true;
			data: any;
	  }
> => {
	try {
		const resp = await axiosInstance.post(`/Backend/Execute`, {
			method: "REF.InstallUpdateToCurrent",
			parameters: [
				{
					name: "Days",
					value: days,
				},
			],
			commandTimeout: 300,
		});

		return {
			ok: true,
			data: resp.data,
		};
	} catch (e) {
		return {
			ok: false,
			message: getError(e),
		};
	}
};
